import { useQuery } from '@tanstack/react-query';
import { promptService } from '../../services/promptService';
import { queryKeys } from '../../lib/react-query';
import { DEFAULT_REPORT_REASONS } from '../../constants/reportReasons';

interface ReportReasonsResponse {
  reasons: Record<string, string>;
}

export function useReportReasons() {
  return useQuery<ReportReasonsResponse>({
    queryKey: queryKeys.reports.reasons(),
    queryFn: async () => {
      const data = await promptService.getReportReasons();
      return data ?? { reasons: DEFAULT_REPORT_REASONS };
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    placeholderData: { reasons: DEFAULT_REPORT_REASONS },
  });
}
